<h2 mat-dialog-title>Copying SRD object...</h2>
<mat-dialog-content class="mat-typography" *ngIf="templates">
  <div class="form-container">
    <mat-form-field>
      <input matInput placeholder="Search..." [(ngModel)]="search" (keyup)="filterTemplates()">
    </mat-form-field>
  </div>
  <div class="results" *ngIf="filteredTemplates?.length">
    <mat-list>
      <mat-list-item *ngFor="let obj of filteredTemplates" class="hoverable pointer"
                     (click)="select(obj)">
        {{data.namer(obj)}}
      </mat-list-item>
    </mat-list>
  </div>
  <div class="results" *ngIf="!filteredTemplates?.length">
    No results found.
  </div>
</mat-dialog-content>

<mat-dialog-content class="mat-typography" *ngIf="!templates">
  <mat-spinner [diameter]="24"></mat-spinner>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
